import * as React from 'react';
import InlineFieldAction from "./InlineFieldAction";
import InlineFieldInfoAction from "./InlineFieldInfoAction";
import { Flex, Divider } from "../..";

var InlineFieldActions = function InlineFieldActions(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center"
  }, children);
};

export { InlineFieldActions };
export default InlineFieldActions;